import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {AdminOrganisation} from '@models/generated.model';
import {AdminService} from '@services/api-services/admin.service';

export const adminOrgResolver: ResolveFn<AdminOrganisation> = (route, state) => {
    const service = inject(AdminService);
    return service.getOrganisation(Number(<string>route.paramMap.get('id')));
  };
